<template>
  <div>
    <v-dialog v-model="value" max-width="450" persistent>
      <v-card>
        <template v-if="delay > 0">
          <v-card-title class="d-flex justify-center pt-5 pb-3">
            <div style="font-size: 22px; font-weight: bold;">
              {{ title }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="d-flex justify-center pb-3">
              <v-icon color="warning" style="font-size: 75px;">mdi-alert</v-icon>
            </div>
            <div class="text-detail-delay">
              <div class="text-center mb-3 error--text" style="width: 100%;">
                <div>{{ $t('validate.warning_important') }}</div>
              </div>
            </div>
            <div v-if="text" class="text-detail-delay">
              <div class="text-center" style="width: 100%;">
                <div>{{ text }}</div>
                <div v-if="subText">{{ subText }}</div>
              </div>
            </div>
            <div class="d-flex justify-center">
              <v-checkbox
                v-model="isCheck"
                class="mt-3"
                hide-details
                color="success"
              >
                <template v-slot:label>
                  <div class="black--text">
                    {{ $t('validate.confirm_data_correct') }}
                  </div>
                </template>
              </v-checkbox>
            </div>
          </v-card-text>
        </template>

        <template v-else>
          <v-card-title class="d-flex justify-center pt-5 pb-3">
            <div style="font-size: 22px; font-weight: bold;">
              {{ title || (type == 'error' ? $t('validate.you_want_to_delete_data') : title) }}
            </div>
          </v-card-title>
          <v-card-text :class="textClass">
            <div v-if="isNote || text" class="text-detail">
              <div class="text-center" style="width: 100%;">
                <div>{{ text }}</div>
                <div v-if="subText" class="mt-2">{{ subText }}</div>
                <v-textarea
                  v-if="isNote"
                  v-model="note"
                  :placeholder="$t('note')"
                  class="mt-3"
                  outlined
                  hide-details
                  flat
                  rows="3"
                />
              </div>
            </div>
          </v-card-text>
        </template>
        <v-card-actions class="border-t">
          <div class="d-flex justify-center gap-4 mx-auto" :style="isSingleButton ? 'width: 60%' : 'width: 100%'">
            <div v-if="!isSingleButton" style="width: 100%;">
              <v-btn 
                outlined
                color="gray"
                @click="onCancel()"
                block
                :disabled="!value || disabled"
              >
                {{ textBtnCancel ? textBtnCancel : $t('cancel') }}
              </v-btn>
            </div>
            <div style="width: 100%;">
              <v-btn
                elevation="0"
                :color="type"
                @click="onAgree()" 
                :disabled="!value || disabled || (isConfirmCheck && !isCheck)" 
                block
              >
                {{ textBtnOk ? textBtnOk : $t('confirm') }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: String,
    text: String,
    textBtnOk: String,
    textBtnCancel: String,
    type: {
      type: String,
      default: 'success'
    },
    textClass: String,
    delay: Number,
    isSingleButton: Boolean,
    disabled: Boolean,
    isNote: Boolean,
    subText: String,
    isConfirmCheck: Boolean,
  },
  watch: {
    value(value) {
      if (value) {
        this.isCheck = false;
      }
    }
  },
  data() {
    return {
      countDown: 0,
      note: '',
      isCheck: false
    };
  },
  methods: {
    onAgree() {
      this.$emit("onOk", { note: this.note });
      this.$emit("input", false);
    },
    onCancel() {
      this.$emit("onCancel", true);
      this.$emit("input", false);
    }
  }
};
</script>

<style scoped>
.text-detail {
  color: var(--v-darkgray-base);
  min-height: 100px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.text-detail-delay {
  color: var(--v-darkgray-base);
  font-size: 16px;
  width: 100%;
}
</style>